<template>
  <div class="container-fluid">
    <div class="row justify-content-between sticky"
         style="color: #495057;background-color: #e9ecef; border-color: #dee2e6;">
<!--      <div class="col-2 font-weight-bolder pt-1">-->
<!--        <p class="font-weight-bolder">#</p>-->
<!--      </div>-->
      <div class="col-7 pt-1">
        <p class="font-weight-bolder">SUBJECT</p>
      </div>
      <div class="col-2 font-weight-bolder pt-1">
        <p class="font-weight-bolder">LETTER NUMBER</p>
      </div>
      <div class="col-1 font-weight-bolder pt-1">
        <p class="font-weight-bolder">DATE</p>
      </div>
      <div class="col-1 font-weight-bolder pt-1">
        <p class="font-weight-bolder">CAT</p>
      </div>
      <div class="col-1 font-weight-bolder pt-1">
        <p class="font-weight-bolder">ACTION</p>
      </div>
    </div>
    <template v-show="items && items.length > 0">
      <custom-table-tree
          v-for="(node,index) in items" :key="index + (crewPagination.perPage*crewPagination.currentPage)"
          :node="node" :index="index + 1" :prefix="[((crewPagination.perPage*(crewPagination.currentPage-1))+index) + 1]"
          @addLetter="openAddLetterNoModal"
          @editCircularInfo="editCircularInfoModal"
          @deletedCircular="$emit('confirmedDeleteCircular')"
          @editAttachmentInfo="editAttachmentModal"
      ></custom-table-tree>
    </template>
    <div v-show="loading">
      <base-loader></base-loader>
    </div>
    <base-modal id="add-letter_no" title="Add Letter No." size="lg"
                @resetField="resetUpload">
      <template #modal-form>
        <div class="modal-body">
          <form action="">
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="subject">Subject</label>
              <div class="col-10">
                <input id="subject" v-model="uploadForm.subject" required
                       class="form-control"
                       placeholder="Subject"
                       type="text"
                >
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="subject">Category</label>
              <div class="col-10 text-left">
                <p style="word-wrap: break-word">{{ setterCircular.circular_category }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="subject">Circular</label>
              <div class="col-10 text-left">
                <p style="word-wrap: break-word">{{ setterCircular.subject }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="subject">Date</label>
              <div class="col-10">
                <input id="date" v-model="uploadForm.date" class="form-control" required name="date" type="date">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="subject">Choose File</label>
              <div class="col-10">
                <input id="attachment" ref="circular_attachments"
                       :accept="[
                          '.doc',
                          '.docx',
                          'application/msword',
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                          'application/pdf',
                          '.xls',
                          '.xlsx',
                          'application/vnd.ms-excel',
                          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                          'application/vnd.ms-excel.sheet.macroEnabled.12',
                          'application/vnd.sealed.eml',
                          'message/rfc822',
                          'application/octet-stream',
                          '.zip',
                          'application/zip',
                          'application/x-zip-compressed'
                      ].join(',')"
                       class="form-control" name="attachment"
                       type="file"
                       @change="changeAttachment"
                >
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-success" @click.prevent="verifyAddCircular">
                <font-awesome-icon icon="save"></font-awesome-icon>
                Save
              </button>
            </div>
          </form>

        </div>
      </template>
    </base-modal>
    <base-modal id="update-circular" title="Update Circular" size="lg"
                @resetField="resetUpload">
      <template #modal-form>
        <div class="modal-body">
          <form action="">
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="edit-subject">Subject</label>
              <div class="col-10">
                <input id="edit-subject" v-model="updateForm.subject"
                       class="form-control"
                       placeholder="Subject"
                       type="text"
                >
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left">Category</label>
              <div class="col-10 text-left">
                <p v-if="updateForm.parent_id">{{ updateForm.circular_category }}</p>
                <custom-select
                    v-else
                    v-model="updateForm.circular_category_id"
                    :items="circular_categories"
                    children="sub_categories"
                    selection-display="Category"
                ></custom-select>
              </div>
            </div>
            <div class="form-group row" v-show="isSystemAdmin && updateForm.parent_id">
              <label class="col-2 col-form-label text-left" for="subject">Circular</label>
              <div class="col-10 text-left">
                <input
                    :value="updateForm.parent_id ? updateForm.parent : null"
                    class="form-control form-control-sm text-left bg-white" data-target="#select-circular"
                    data-toggle="modal"
                    readonly type="button">

<!--                <input-->
<!--                    :value="updateForm.subject"-->
<!--                    class="form-control form-control-sm text-left bg-white"-->
<!--                    readonly type="button"-->
<!--                >-->
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="edit-date">Date</label>
              <div class="col-10">
                <input id="edit-date" v-model="updateForm.date" class="form-control" name="date" required type="date">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label text-left" for="edit-attachment">Choose File</label>
              <div class="col-10">
                <input id="edit-attachment" ref="circular_attachment"
                       :accept="[
                          '.doc',
                          '.docx',
                          'application/msword',
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                          'application/pdf',
                          '.xls',
                          '.xlsx',
                          'application/vnd.ms-excel',
                          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                          'application/vnd.ms-excel.sheet.macroEnabled.12',
                          'application/vnd.sealed.eml',
                          '.zip',
                          'image/apng',
                          'image/avif',
                          'image/gif',
                          'image/jpeg',
                          'image/png',
                          'image/svg+xml',
                          'image/webp',
                          'message/rfc822',
                          'application/vnd.ms-powerpoint',
                          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                          'application/octet-stream',
                          'application/zip',
                          'application/x-zip-compressed'
                        ].join(',')"
                       class="form-control" name="attachment"
                       type="file"
                       @change="changeAttachment"
                >
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-success" @click.prevent="updateCircularInfo">
                <font-awesome-icon icon="save"></font-awesome-icon>
                Save
              </button>
            </div>
          </form>

        </div>
      </template>
    </base-modal>
    <base-modal id="select-circular" size="xl" title="'SELECT CIRCULAR" @resetField="resetUpload">
      <template #modal-form>
        <select-circular
            @setSelected="setSelectedCircular"
            :circular-category-id="convertToNum(updateForm.circular_category_id)"
            :circular-issue-id="convertToNum(updateForm.circular_issue_id)">
        </select-circular>
      </template>
    </base-modal>
    <base-modal id="edit-circular-attachment"
                @resetField="resetUploadAttachment"
                :title="'UPDATE ATTACHMENT'">
      <template #modal-form>
        <div class="modal-body">
          <div class="form-group row">
            <label for="attachments" class="col-2 col-form-label text-left">Subject</label>
            <div class="col-10">
              <input type="text" disabled class="form-control form-control-sm" :value="selected_circular.subject">
            </div>
          </div>
          <div class="form-group row">
            <label for="attachments" class="col-2 col-form-label text-left">Choose File simon</label>
            <div class="col-10">
              <input type="file" name="attachment"
                     accept="application/vnd.cups-pdf,application/pdf"
                     id="attachments" class="form-control"
                     ref="attachments"
                     required
                     @change="changeAttachment"
              >
            </div>
          </div>
          <div class="form-group row">
            <label for="date-add" class="col-2 col-form-label text-left">Date</label>
            <div class="col-10">
              <input type="date"
                     v-model="uploadCircularAttachment.date"
                     id="date-add" class="form-control"
              >
            </div>
          </div>
          <div class="text-right">
            <button
                @click.prevent="verifyUpdateAttachment"
                class="btn btn-sm btn-success">
              <font-awesome-icon icon="file-upload" class="mr-2"
              />
              UPDATE ATTACHMENT
            </button>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import CustomTableTree from '@/components/CustomTableTree';
import BaseLoader from '@/components/base/BaseLoader';
import {AlertService} from '@/service/alert.service';
import {AppService} from '@/service/app.service';
import BaseModal from '@/components/base/BaseModal';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import CustomSelect from '@/components/CustomSelect';
import SelectCircular from '@/components/SelectCircular';
import {toNumber} from 'lodash';
import {UacMixins} from '@/mixins/uac.mixins';

export default {
  name: 'CustomTreeTable',
  props: {
    items: {
      type: [Object, Array],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {CustomTableTree, BaseLoader, BaseModal, CustomSelect, SelectCircular},
  mixins:[UacMixins],
  data() {
    return {
      setterCircular: {
        subject: '',
        circular_category: '',
      },
      uploadForm: {
        circular_issue_id: null,
        circular_category_id: null,
        parent_id: null,
        subject: null,
        date: null,
      },
      uploadCircularAttachment: {
        date: '',
      },
      updateForm: {},
      selectedCircular: '',
    };
  },
  computed: {
    ...mapGetters([
      'selected_circular',
      'circular_categories',
      'circular_issues',
      'circularsForSelection',
      'authUser',
      'crewPagination'
    ]),
  },
  methods: {
    ...mapMutations(
        [
          'SET_SELECTED_CIRCULAR',
          'SET_CIRCULARS_FOR_SELECTION',
        ],
    ),
    ...mapActions([
      'addCircular',
      'updateCircular',
      'updateAttachment',
    ]),
    async verifyAddCircular() {
      if (
          await AlertService.questionAlertService(
              `Do you want to add this letter to ?
               <br>
               <p style="white-space:break-spaces"><b>${this.setterCircular.subject}</b></p>
              `, 'ADD LETTER', 'question')
      ) {
        let form = AppService.generateFormData(this.uploadForm, this.attachment);
        let response = await this.addCircular(form);
        if (!response.errors) {
          this.resetUpload();
          AlertService.successAlertService('A letter has been added', 'ADD LETTER NO.');
          $('#add-letter_no').modal('hide');
        }
      }
    },
    changeAttachment(event) {
      this.attachment = event.target.files[0];
    },
    resetUpload() {
      this.uploadForm = Object.assign({}, {
        circular_issue_id: null,
        circular_category_id: null,
        parent_id: null,
        subject: null,
        date: null,
      });
      // this.updateForm = Object.assign({}, {});
      this.SET_SELECTED_CIRCULAR({
        circular_issue_id: null,
        circular_category_id: null,
        parent_id: null,
        subject: null,
        date: null,
      });
      this.SET_CIRCULARS_FOR_SELECTION([]);
      this.attachment = '';
      this.selectedCircular = null;
      this.$refs.circular_attachment.value = null;
      this.$refs.circular_attachments.value = null;
    },
    openAddLetterNoModal(circular) {
      this.setterCircular = circular;
      this.uploadForm.circular_issue_id = circular.circular_issue_id;
      this.uploadForm.circular_category_id = circular.circular_category_id;
      this.uploadForm.parent_id = circular.id;
      this.$nextTick(() => {
        $('#add-letter_no').modal('show');
      });
    },
    setSelectedCircular(circular) {
      this.updateForm.parent_id = circular.id;
      this.updateForm.parent = circular.subject;
      this.SET_CIRCULARS_FOR_SELECTION([]);
      $('#select-circular').modal('hide');
    },
    async updateCircularInfo() {
      if (
          await AlertService.questionAlertService(
              `Do you want to update this circular?
               <br>
               <p style="white-space:break-spaces"><b>${this.setterCircular.subject}</b></p>
              `, 'UPDATE CIRCULAR', 'question')
      ) {
        let form = AppService.generateFormData(this.updateForm, this.attachment);
        let response = await this.updateCircular(form);
        if (!response.errors) {
          this.resetUpload();
          AlertService.successAlertService('A circular has been updated', 'ADD LETTER NO.');
          $('#update-circular').modal('hide');
        }
        // this.$emit('confirmUpdateCircular');
      }
    },
    editCircularInfoModal(circular) {
      this.setterCircular = circular;
      this.updateForm = Object.assign({}, {
        id: circular.id,
        parent_id: circular.parent_id ? circular.parent_id : null,
        subject: circular.subject,
        circular_issue_id: circular.circular_issue_id,
        circular_category_id: circular.circular_category_id,
        date: circular.date,
        parent: circular.parent,
        circular_category: circular.circular_category,
      });
      this.$nextTick(() => {
        $('#update-circular').modal('show');
      });
    },
    convertToNum(number) {
      return toNumber(number);
    },
    editAttachmentModal({attachment, circular}) {
      this.SET_SELECTED_CIRCULAR(circular);
      this.uploadCircularAttachment.date = attachment.date;
      this.uploadCircularAttachment.id = attachment.id;
      this.uploadCircularAttachment.circular_id = circular.id;
      this.$nextTick(() => {
        $('#edit-circular-attachment').modal('show');
      });
    },
    async verifyUpdateAttachment() {
      if (await AlertService.questionAlertService(
          `Do you want to update attachment on
                 <br>
                 <p style="white-space:break-spaces"><b>${this.selected_circular.subject}</b></p>
                 </br>`,
          'UPDATE ATTACHMENT', 'question')
      ) {
        let form = AppService.generateFormData(this.uploadCircularAttachment, this.attachment, 'attachments');
        let response = await this.updateAttachment(form);
        if (!response.errors) {
          AlertService.successAlertService('Attachment updated successfully', 'UPDATE ATTACHMENT');
          this.resetUploadAttachment();
          $('#edit-circular-attachment').modal('hide');
        }
      }
    },
    resetUploadAttachment() {
      this.$refs.attachments.value = null;
      this.uploadCircularAttachment = Object.assign({}, {});
    },
  },

  mounted() {

  },
};
</script>

<style scoped>

div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
}

</style>
